/**
 * Chilean national phone numbers (without +56 country code) are 9 digits.
 * Used across checkout, account address book and auth.
 */
export const CHILE_PHONE_LENGTH = 9

export const CHILE_PHONE_DIGITS_PATTERN = /^[0-9]*$/

/** react-hook-form rules shared by telephone / telefono fields */
export const chilePhoneRegisterOptions = {
    required: true,
    pattern: CHILE_PHONE_DIGITS_PATTERN,
    maxLength: CHILE_PHONE_LENGTH,
    minLength: CHILE_PHONE_LENGTH
} as const

export const clampChilePhone = (value: string): string => {
    let digits = value.replace(/\D/g, '')
    // If pasted with country code (+56...), keep the national 9 digits
    if (digits.startsWith('56') && digits.length > CHILE_PHONE_LENGTH) {
        digits = digits.slice(2)
    }
    return digits.slice(0, CHILE_PHONE_LENGTH)
}

export const isChilePhoneDigitKey = (key: string): boolean =>
    Boolean(key.match(/^[0-9]*$/))

export const isValidChilePhone = (value?: string | null): boolean =>
    clampChilePhone(value ?? '').length === CHILE_PHONE_LENGTH
